import { cva } from 'class-variance-authority';
import type { PillColorsEnum } from '../types';

const pillVariants = cva(
  'border w-fit border-box flex flex-row shrink-0 justify-center items-center border-secondary',
  {
    variants: {
      variant: {
        soft: '',
        clear: 'border-secondary bg-primary',
        solid: 'text-white border-none',
      },
      color: {
        gray: '',
        brand: '',
        error: '',
        warning: '',
        success: '',
        blue: '',
        purple: '',
        fuchsia: '',
        cyan: '',
        lime: '',
        pink: '',
        violet: '',
        indigo: '',
        rose: '',
        yellow: '',
      } satisfies Record<PillColorsEnum, string>,
      shape: {
        rounded: 'rounded-full py-xs',
        square: 'rounded-sm py-xs',
      },
      size: {
        md: '!p-md h-fit',
        sm: 'px-md h-6',
        xs: 'px-sm h-5',
      },
      disabled: {
        true: '!bg-disabled',
      },
    },
    compoundVariants: [
      {
        variant: 'soft',
        color: 'gray',
        className: 'border-utility-gray-100 bg-utility-gray-50',
      },
      {
        variant: 'soft',
        color: 'brand',
        className: 'border-utility-brand-100 bg-utility-brand-50',
      },
      {
        variant: 'soft',
        color: 'error',
        className: 'border-utility-error-100 bg-utility-error-50',
      },
      {
        variant: 'soft',
        color: 'warning',
        className: 'border-utility-warning-100 bg-utility-warning-50',
      },
      {
        variant: 'soft',
        color: 'success',
        className: 'border-utility-success-100 bg-utility-success-50',
      },
      {
        variant: 'soft',
        color: 'blue',
        className: 'border-utility-blue-100 bg-utility-blue-50',
      },
      {
        variant: 'soft',
        color: 'purple',
        className: 'border-utility-purple-100 bg-utility-purple-50',
      },
      {
        variant: 'soft',
        color: 'fuchsia',
        className: 'border-utility-fuchsia-100 bg-utility-fuchsia-50',
      },
      {
        variant: 'soft',
        color: 'cyan',
        className: 'border-utility-cyan-100 bg-utility-cyan-50',
      },
      {
        variant: 'soft',
        color: 'lime',
        className: 'border-utility-lime-100 bg-utility-lime-50',
      },
      {
        variant: 'soft',
        color: 'pink',
        className: 'border-utility-pink-100 bg-utility-pink-50',
      },
      {
        variant: 'soft',
        color: 'violet',
        className: 'border-utility-violet-100 bg-utility-violet-50',
      },
      {
        variant: 'soft',
        color: 'indigo',
        className: 'border-utility-indigo-100 bg-utility-indigo-50',
      },
      {
        variant: 'soft',
        color: 'rose',
        className: 'border-utility-rose-100 bg-utility-rose-50',
      },
      {
        variant: 'solid',
        color: 'brand',
        className: 'bg-utility-brand-600',
      },
      {
        variant: 'solid',
        color: 'gray',
        className: 'bg-utility-gray-600',
      },
      {
        variant: 'solid',
        color: 'error',
        className: 'bg-utility-error-600',
      },
      {
        variant: 'solid',
        color: 'warning',
        className: 'bg-utility-warning-600',
      },
      {
        variant: 'solid',
        color: 'success',
        className: 'bg-utility-success-600',
      },
      {
        variant: 'solid',
        color: 'blue',
        className: 'bg-utility-blue-600',
      },
      {
        variant: 'solid',
        color: 'purple',
        className: 'bg-utility-purple-600',
      },
      {
        variant: 'solid',
        color: 'fuchsia',
        className: 'bg-utility-fuchsia-600',
      },
      {
        variant: 'solid',
        color: 'cyan',
        className: 'bg-utility-cyan-600',
      },
      {
        variant: 'solid',
        color: 'lime',
        className: 'bg-utility-lime-600',
      },
      {
        variant: 'solid',
        color: 'pink',
        className: 'bg-utility-pink-600',
      },
      {
        variant: 'solid',
        color: 'violet',
        className: 'bg-utility-violet-600',
      },
      {
        variant: 'solid',
        color: 'indigo',
        className: 'bg-utility-indigo-600',
      },
      {
        variant: 'solid',
        color: 'rose',
        className: 'bg-utility-rose-600',
      },
      {
        variant: 'solid',
        color: 'yellow',
        className: 'bg-utility-warning-300',
      },
    ],
    defaultVariants: {},
  },
);

export default pillVariants;
